import React, { useState, useEffect, useContext, useRef } from "react";
import { MaintenanceContext } from "context/maintenanceProvider";
import { useParams } from "react-router-dom";
import {
  Breadcrumb,
  Button,
  Divider,
  Form,
  Header,
  Icon,
  Rating,
  Segment,
  Table,
} from "semantic-ui-react";
import Navigation from "components/navigation";
import Sidebar from "components/sidebar";
import "scss/screens/maintenancePending/pendingOrderDetail.scss";
import MaintenanceHandle from "components/maintenance/maintenanceHandle";
import LetterLoading from "components/loading/letterLoading";
import Swal from "sweetalert2";
import SignaturePad from "react-signature-canvas";
import MaintenanceAdd from "components/maintenance/maintenanceAdd";
import { DeviceContext } from "context/deviceProvider";
import { END_POINT } from "context/endPoint";
import dataURLtoBlob from "blueimp-canvas-to-blob";
import { UserContext } from "context/userProvider";

export default function PendingOrderDetail() {
  const [isLoading, setIsLoading] = useState(false);
  const [customerForm, setCustomerForm] = useState(false);
  const [maintenanceDetail, setMaintenanceDetail] = useState([]);
  const [deviceForm, setDeviceForm] = useState(null);
  const [riceMill, setRiceMill] = useState([]);
  const [longTail, setLongTail] = useState([]);
  const [agricuture, setAgricuture] = useState([]);
  const [maintenanceImage, setMaintenanceImage] = useState([]);
  const [reviewForm, setReviewForm] = useState({});
  const [imageURL, setImageURL] = useState(null);
  const [rejectPart, setRejectPart] = useState([{ partName: "", qty: 0 }]);
  const maintenances = useContext(MaintenanceContext);
  const devices = useContext(DeviceContext);
  const users = useContext(UserContext);
  const sigCanvas = useRef({});
  const { id } = useParams();

  const [adjustPart, setAdjustPart] = useState([{ partName: "", qty: 0 }]);

  useEffect(() => {
    setIsLoading(true);
    setMaintenanceData();
  }, []);

  const setMaintenanceData = async () => {
    await devices.getMasterParts({ model: "" });
    await maintenances.getMaintenance({ state: [] });
    let data = await maintenances.maintenanceList.filter(
      (order) => order.documentNo === id
    );
    setMaintenanceDetail(data.length > 0 ? data[0] : []);
    setReviewForm(data[0]?.reviewForm != null ? data[0]?.reviewForm : {});
    setDeviceForm(data[0]?.form != null ? data[0]?.form : null);
    setRejectPart(
      data[0]?.rejectPartList?.length > 0
        ? data[0]?.rejectPartList
        : [{ partName: "", qty: 0 }]
    );

    setAdjustPart(
      data[0]?.adjustPartList?.length > 0
        ? data[0]?.adjustPartList
        : [{ partName: "", qty: 0 }]
    );

    setMaintenanceImage(
      data[0]?.images?.process?.length > 0 ? data[0]?.images?.process : []
    );
    setIsLoading(false);
    console.log("getdata",maintenanceDetail);
  };

  const alertDialog = (title, text, icon) => {
    Swal.fire({
      title: title,
      text: text,
      icon: icon,
    });
  };

  const onSelectImage = (e) => {
    console.log("e.target.files: " + e.target.files.length);
    if (maintenanceImage.length < 10 && e.target.files.length < 11) {
      let files = Array.from(e.target.files).map((image) => image);
      setMaintenanceImage([...maintenanceImage, ...files]);
    } else {
      alertDialog("Error!", "ไม่สามารถอัพโหลดรูปภาพได้เกิน 10 รูป", "error");
    }
  };

  const onGetMonth = (month) => {
    const monthNames = [
      "มกราคม",
      "กุมภาพันธ์",
      "มีนาคม",
      "เมษายน",
      "พฤษภาคม",
      "มิถุนายน",
      "กรกฎาคม",
      "สิงหาคม",
      "กันยายน",
      "ตุลาคม",
      "พฤศจิกายน",
      "ธันวาคม",
    ];
    return monthNames[parseInt(month) - 1];
  };

  const onUpdateTimeFormat = (date) => {
    let updateDate =
      date
        .toLocaleDateString("ko-KR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .replaceAll(". ", "-")
        .replaceAll(".", " ") + date.toTimeString().substring(0, 8);

    return updateDate;
  };

  const onUpdateMaintenance = async (button) => {
    if (button === "reject") {
      const data = { id: maintenanceDetail.id, isReturn: 1, state: "received" };
      const formData = new FormData();
      formData.append("data", JSON.stringify(data));

      let result = await maintenances.updateMaintenanceWithImage(formData);
      if (result?.code === 0) {
        return alertDialog("Success!", result?.description, "success");
      } else {
        return alertDialog("Error!", result?.description, "error");
      }
    }
    if (
      maintenanceDetail?.detectCause == null ||
      maintenanceDetail?.problemSolvingSolution == null
    ) {
      return alertDialog("Warning!", "กรุณากรอกข้อมูลให้ครบถ้วน", "error");
    }

    const data = {
      confirmSerial: maintenanceDetail.confirmSerial,
      detectCause: maintenanceDetail.detectCause,
      maintenanceDate: maintenanceDetail?.beginMaintenanceDate,
      maintenanceNote: maintenanceDetail.maintenanceNote,
      id: maintenanceDetail.id,
      problemSolvingSolution: maintenanceDetail.problemSolvingSolution,
      rejectPartList: rejectPart,
      adjustPartList: adjustPart,
      beginMaintenanceDate: maintenanceDetail.beginMaintenanceDate,
      endMaintenanceDate: maintenanceDetail.endMaintenanceDate,
      reviewForm: reviewForm,
      form: deviceForm,
      state: button === "approve" ? "finish" : "process",
      isComplete: button === "approve" ? 1 : 0,
      isReturn: button === "reject" ? 1 : 0,
      workerId: "manager",
    };
    console.log("datas",data);
    const formData = new FormData();
    maintenanceImage?.map((image) => formData.append("file", image));

    if (imageURL != null && !reviewForm?.signature) {
      formData.append("signatureImage", imageURL, "signature.png");
    }
    formData.append("data", JSON.stringify(data));
  
    //! ----------- update maintenance -----------
    let result = await maintenances.updateMaintenanceWithImage(formData);
    if (result?.code === 0) {
      return alertDialog("Success!", result?.description, "success");
    } else {
      return alertDialog("Error!", result?.description, "error");
    }
  };

  // const getTotalActivateSec = (number) => {
  //   let hours = Math.floor(number / 3600);
  //   number %= 3600;
  //   let minutes = Math.floor(number / 60);
  //   let seconds = number % 60;
  //   if (hours < 1) {
  //     if (minutes < 1) return `${seconds} วินาที`;
  //     else return `${minutes} นาที ${seconds} วินาที`;
  //   } else {
  //     if (minutes < 1) return `${hours} ชั่วโมง ${seconds} วินาที`;
  //     else return `${hours} ชั่วโมง ${minutes} นาที ${seconds} วินาที`;
  //   }
  // };

  //คำนวณระยะเวลาในการซ่อม
  const getTotalActivateSec = (totalActivateMs) => {
    if (!maintenanceDetail.beginMaintenanceDate || !maintenanceDetail.endMaintenanceDate) {
      return "";
    }
    const beginTimeMs = new Date(maintenanceDetail.beginMaintenanceDate).getTime();
    const endTimeMs = new Date(maintenanceDetail.endMaintenanceDate).getTime();

    const diffMs = endTimeMs - beginTimeMs;
    return formatTime(Math.floor(diffMs / 1000));
  };
  
  const formatTime = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds - (hours * 3600)) / 60);
    const seconds = totalSeconds - (hours * 3600) - (minutes * 60);
    
    const hoursStr = hours < 10 ? `0${hours}` : `${hours}`;
    const minutesStr = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const secondsStr = seconds < 10 ? `0${seconds}` : `${seconds}`;
  
    if (hours === 0) {
      return `${minutesStr} นาที ${secondsStr} วินาที`;
    } else if (hours > 0 && minutes === 0) {
      return `${hoursStr} ชั่วโมง`;
    } else {
      return `${hoursStr} ชั่วโมง ${minutesStr} นาที ${secondsStr} วินาที`;
    }
  }

  const createMaintenanceForm = () => {
    return (
      <Segment>
        <table className="maintenance">
          <tbody>
            <tr>
              <td>
                สาเหตุที่ตรวจพบ <span>*</span>
              </td>
              <td>
                <Form>
                  <input
                    type="text"
                    placeholder="สาเหตุที่ตรวจพบ"
                    value={maintenanceDetail?.detectCause}
                    onChange={(e) =>
                      setMaintenanceDetail({
                        ...maintenanceDetail,
                        detectCause: e.target.value,
                      })
                    }
                  />
                </Form>
              </td>
            </tr>
            <tr>
              <td>
                การดำเนินการซ่อม <span>*</span>
              </td>
              <td>
                <Form>
                  <input
                    type="text"
                    placeholder="การดำเนินการซ่อม"
                    value={maintenanceDetail?.problemSolvingSolution}
                    onChange={(e) =>
                      setMaintenanceDetail({
                        ...maintenanceDetail,
                        problemSolvingSolution: e.target.value,
                      })
                    }
                  />
                </Form>
              </td>
            </tr>
            <tr>
              <td>การตั้งค่าเครื่องจักร</td>
              <td>{selectDeviceType()}</td>
            </tr>
            <tr>
              <td>อะไหล่ที่ใช้เพิ่มเติมหน้างาน</td>
              <td>{getAdjustPart()}</td>
            </tr>
            <tr>
              <td>อะไหล่ที่นำกลับ</td>
              <td>{getRejectPart()}</td>
            </tr>
            <tr>
              <td>หมายเหตุ</td>
              <td>
                <Form>
                  <Form.TextArea
                    placeholder="หมายเหตุ"
                    value={maintenanceDetail?.maintenanceNote || ""}
                    onChange={(e) =>
                      setMaintenanceDetail({
                        ...maintenanceDetail,
                        maintenanceNote: e.target.value,
                      })
                    }
                  />
                </Form>
              </td>
            </tr>
          </tbody>
        </table>
      
        <div>
          <Divider horizontal>
            <Header as="h3">
              <Icon name="wrench" />
              วันที่ทำการแก้ไข 
            </Header>
          </Divider>
          <table className="maintenance">
          <tbody>
            <tr>
              <td>
                วันที่ทำการแก้ไข <span>*</span>
              </td>
              <td>
                <Form>
                  <input
                    type="text"
                    placeholder="วันที่ทำการแก้ไข"
                    value={
                      (maintenanceDetail?.beginMaintenanceDate &&
                        `${maintenanceDetail?.beginMaintenanceDate.substring(
                          8,
                          10
                        )} ${onGetMonth(
                          maintenanceDetail?.beginMaintenanceDate.substring(
                            5,
                            7
                          )
                        )} ${
                          parseInt(
                            maintenanceDetail?.beginMaintenanceDate.substring(
                              0,
                              4
                            )
                          ) + 543
                        }`) ||
                      `${onUpdateTimeFormat(new Date()).substring(
                        8,
                        10
                      )} ${onGetMonth(
                        onUpdateTimeFormat(new Date()).substring(5, 7)
                      )} ${
                        parseInt(
                          onUpdateTimeFormat(new Date()).substring(0, 4)
                        ) + 543
                      }`
                    }
                    readOnly
                  />
                </Form>
              </td>
            </tr>
            
            <tr>
              <td>เวลาเริ่มซ่อม</td>
              <td>
                <Form>
                  <Form.Group inline>
                    <Button
                      color="teal"
                      onClick={(e) =>
                        setMaintenanceDetail({
                          ...maintenanceDetail,
                          beginMaintenanceDate: onUpdateTimeFormat(new Date()),
                        })
                      }
                    >
                      เริ่มซ่อม
                    </Button>
                    &emsp;
                    <p>เริ่ม: {maintenanceDetail?.beginMaintenanceDate}</p>
                  </Form.Group>
                </Form>
              </td>
            </tr>
            <tr>
              <td>เวลาที่ซ่อมเสร็จ</td>
              <td>
                <Form>
                  <Form.Group inline>
                    <Button
                      color="red"
                      onClick={(e) =>
                        setMaintenanceDetail({
                          ...maintenanceDetail,
                          endMaintenanceDate: onUpdateTimeFormat(new Date()),
                        })
                      }
                    >
                      ซ่อมเสร็จ
                    </Button>
                    &emsp;
                    <p>เสร็จ: {maintenanceDetail?.endMaintenanceDate}</p>
                  </Form.Group>
                </Form>
              </td>
            </tr>
            {(maintenanceDetail?.beginMaintenanceDate != null ||
              maintenanceDetail?.endMaintenanceDate != null) && (
              <tr>
                <td>เวลารวม</td>
                <td>
                  <Form>
                    <input
                      type="text"
                      placeholder="เวลารวม (วินาที)"
                      value={getTotalActivateSec(
                        maintenanceDetail?.totalActivateSec
                      )}
                      readOnly
                    />
                  </Form>
                </td>
              </tr>
            )}
          </tbody>
        </table>
        </div>
        
        {createHandleImage()}
        {/* {
          // maintenanceDetail?.reviewForm == null &&
          createCustomerForm()
        } */}
      </Segment>
    );
  };

  const selectDeviceType = () => {
    return (
      <>
        <Form>
          <Form.Checkbox
            label="เครื่องสีข้าว"
            value="riceMill"
            checked={deviceForm?.deviceType === "riceMill"}
            onChange={(e, { value }) => {
              setDeviceForm({
                ...deviceForm,
                deviceType: value,
              });
            }}
          />
          <Form.Checkbox
            label="เครื่องคัดแยกเมล็ดพันธุ์ เครื่องทำความสะอาด"
            value="seedsorting"
            checked={deviceForm?.deviceType === "seedsorting"}
            onChange={(e, { value }) => {
              setDeviceForm({
                ...deviceForm,
                deviceType: value,
              });
            }}
          />
           <Form.Checkbox
            label="ชุดหางเรือ"
            value="longTail"
            checked={deviceForm?.deviceType === "longTail"}
            onChange={(e, { value }) =>
              setDeviceForm({
                ...deviceForm,
                deviceType: value,
              })
            }
          />
          <Form.Checkbox
            label="เครื่องจักรกลทางการเกษตรอื่นๆ"
            value="agricuture"
            checked={deviceForm?.deviceType === "agricuture"}
            onChange={(e, { value }) => {
              setDeviceForm({
                ...deviceForm,
                deviceType: value,
              });
            }}
          />       
        </Form>
        {deviceForm?.deviceType === "riceMill" && riceMillDevice()}
        {deviceForm?.deviceType === "seedsorting" && seedsorting()}
        {deviceForm?.deviceType === "agricuture" && agricutureDevice()}
        {deviceForm?.deviceType === "longTail" && longTailDevice()}       
      </>
    );
  };

  const createHandleImage = () => {
    return (
      <>
        <Divider horizontal>
          <Header as="h4">
            <Icon name="images" />
            การแก้ไข ({maintenanceImage.length}/10)
          </Header>
        </Divider>
        <div className="images">
          <input type="file" multiple onChange={onSelectImage} />
        </div>
        <div className="addMaintenance">
          {maintenanceImage.length > 0 &&
            maintenanceImage.map((image, idx) => (
              <div key={idx} className="fadein">
                <div onClick={() => removeImage(image.name)} className="delete">
                  <Icon name="times circle" size="large" />
                </div>
                {image.name ? (
                  <img
                    key={`${image.name}-${idx}`}
                    alt="add-maintenance"
                    src={URL.createObjectURL(image)}
                    style={{
                      width: 300,
                      height: 300,
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <img
                    key={idx}
                    alt="add-maintenance"
                    src={`${END_POINT}/get/image?name=${image.path}`}
                    style={{
                      width: 300,
                      height: 300,
                      objectFit: "cover",
                    }}
                  />
                )}
              </div>
            ))}
        </div>
      </>
    );
  };

  const removeImage = (name) => {
    const imageFilter = maintenanceImage.filter((image) => image.name !== name);
    setMaintenanceImage(imageFilter);
  };

  const createCustomerForm = () => {
    console.log(imageURL);
    return (
      <div className="customer">
        <Divider horizontal>
          <Header as="h4">
            <Icon name="paper plane" />
            การประเมินความพึงพอใจของลูกค้า
          </Header>
        </Divider>
        {customerForm === false && (
          <div className="customer-button">
            <Button color="blue" onClick={() => setCustomerForm(!customerForm)}>
              แบบประเมิน
            </Button>
          </div>
        )}

        {customerForm === true && (
          <div className="customer-form">
            <div className="rating">
              <div>
                <h4>ความพึงพอใจในการ SERVICE</h4>
                <Rating
                  maxRating={5}
                  defaultRating={reviewForm?.service}
                  icon="star"
                  size="massive"
                  onRate={(e, { rating }) =>
                    setReviewForm({ ...reviewForm, service: rating })
                  }
                />
              </div>
              <div>
                <h4>ความพึงพอใจเกี่ยวกับผลิตภัณฑ์</h4>
                <Rating
                  maxRating={5}
                  defaultRating={reviewForm?.device}
                  icon="star"
                  size="massive"
                  onRate={(e, { rating }) =>
                    setReviewForm({ ...reviewForm, device: rating })
                  }
                />
              </div>
              <div></div>
            </div>
            <div className="bottom">
              <div>
                <h4>ข้อเสนอแนะของลูกค้า</h4>
                <Form>
                  <Form.TextArea
                    placeholder="ข้อเสนอแนะของลูกค้า"
                    value={reviewForm?.comment}
                    onChange={(e) =>
                      setReviewForm({ ...reviewForm, comment: e.target.value })
                    }
                  />
                </Form>
              </div>
              <div>
                <h4>ลายเซ็นต์ของลูกค้า</h4>
                <>
                  <div className="bottom-sign">
                    {reviewForm?.signature ? (
                      <>
                        <img
                          alt="add-maintenance"
                          src={`${END_POINT}/get/image?name=${reviewForm?.signature}`}
                          style={{
                            // width: 300,
                            // height: 300,
                            objectFit: "cover",
                          }}
                        />
                      </>
                    ) : (
                      <SignaturePad
                        ref={sigCanvas}
                        width={500}
                        canvasProps={{
                          className: "signatureCanvas",
                        }}
                      />
                    )}
                  </div>
                  <div className="bottom-button">
                    {!maintenanceDetail?.reviewForm?.signature && (
                      <>
                        <Button
                          color="blue"
                          onClick={() => {
                            setImageURL(
                              dataURLtoBlob(
                                sigCanvas.current
                                  .getTrimmedCanvas()
                                  .toDataURL("image/png")
                              )
                            );
                            // console.log(imageURL);
                          }}
                        >
                          บันทึก
                        </Button>
                        <Button
                          color="grey"
                          onClick={() => sigCanvas.current.clear()}
                        >
                          ล้างค่า
                        </Button>
                        <Button
                          basic
                          color="red"
                          onClick={() => setCustomerForm(!customerForm)}
                        >
                          ยกเลิก
                        </Button>
                      </>
                    )}
                  </div>
                </>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const riceMillDevice = () => {
    return (
      <>
        <ul>
          <li>
            - ความเร็วรอบมอเตอร์{" "}
            <Form.Input
              type="number"
              placeholder="ความเร็วรอบมอเตอร์"
              value={deviceForm?.motorSpeed}
              onChange={(e) =>
                setDeviceForm({ ...deviceForm, amp: e.target.value })
              }
            />{" "}
            RPM
          </li>

          <li>
            - ความเร็วรอบลูกยางกระเทาะ A {" "}
            <Form.Input
              type="number"
              placeholder="ความเร็วรอบลูกยางกระเทาะ A"
              value={deviceForm?.crackerSpeedA}
              onChange={(e) =>
                setDeviceForm({ ...deviceForm, crackerSpeedA: e.target.value })
              }
            />{" "}
            RPM
          </li>

          <li>
            - ความเร็วรอบลูกยางกระเทาะ B {" "}
            <Form.Input
              type="number"
              placeholder="ความเร็วรอบลูกยางกระเทาะ B"
              value={deviceForm?.crackerSpeedB}
              onChange={(e) =>
                setDeviceForm({ ...deviceForm, crackerSpeedB: e.target.value })
              }
            />{" "}
            RPM
          </li>

          <li>
            - ความเร็วรอบลูกยางกระเทาะ C {" "}
            <Form.Input
              type="number"
              placeholder="ความเร็วรอบลูกยางกระเทาะ C"
              value={deviceForm?.crackerSpeedC}
              onChange={(e) =>
                setDeviceForm({ ...deviceForm, crackerSpeedC: e.target.value })
              }
            />{" "}
            RPM
          </li>

          <li>
            - ความเร็วรอบใบกระเทาะ{" "}
            <Form.Input
              type="number"
              placeholder="ความเร็วรอบใบกระเทาะ"
              value={deviceForm?.crackerSpeed}
              onChange={(e) =>
                setDeviceForm({ ...deviceForm, crackerSpeed: e.target.value })
              }
            />{" "}
            RPM
          </li>
          
          <li>
            - ความเร็วรอบขัดขาว{" "}
            <Form.Input
              type="number"
              placeholder="ความเร็วรอบขัดขาว"
              value={deviceForm?.whitePolishingSpeed}
              onChange={(e) =>
                setDeviceForm({
                  ...deviceForm,
                  whitePolishingSpeed: e.target.value,
                })
              }
            />{" "}
            RPM
          </li>

          <li>
            - ความเร็วรอบพัดลมรำ{" "}
            <Form.Input
              type="number"
              placeholder="ความเร็วรอบพัดลมรำ"
              value={deviceForm?.brandFanSpeed}
              onChange={(e) =>
                setDeviceForm({ ...deviceForm, brandFanSpeed: e.target.value })
              }
            />{" "}
            RPM
          </li>
       
          <li>
            - ความเร็วรอบพัดลมดูดแกลบ{" "}
            <Form.Input
              type="number"
              placeholder="ความเร็วรอบพัดลมดูดแกลบ"
              value={deviceForm?.chaffFanSpeed}
              onChange={(e) =>
                setDeviceForm({ ...deviceForm, chaffFanSpeed: e.target.value })
              }
            />{" "}
            RPM
          </li>

          <li>
            - แรงดันไฟฟ้า{" "}
            <Form.Input
              type="number"
              placeholder="แรงดันไฟฟ้า"
              value={deviceForm?.voltage}
              onChange={(e) =>
                setDeviceForm({ ...deviceForm, voltage: e.target.value })
              }
            />{" "}
            V
          </li>

          <li>
            - กระแสไฟฟ้า ON LOAD{" "}
            <Form.Input
              type="number"
              placeholder="กระแสไฟฟ้า ON LOAD"
              value={deviceForm?.ampOnLoad}
              onChange={(e) =>
                setDeviceForm({ ...deviceForm, ampOnLoad: e.target.value })
              }
            />{" "}
            A
          </li>
         
          <li>
            - กระแสไฟฟ้า NO LOAD{" "}
            <Form.Input
              type="number"
              placeholder="กระแสไฟฟ้า NO LOAD"
              value={deviceForm?.ampNoload}
              onChange={(e) =>
                setDeviceForm({ ...deviceForm, ampNoload: e.target.value })
              }
            />{" "}
            A
          </li>
         
          <li>ประสิทธิภาพในการสีข้าว (ส่วนข้าวกล้อง)</li>
          <li>
            - พันธุ์ข้าว{" "}
            <Form.Input
              type="number"
              placeholder="พันธุ์ข้าว"
              value={deviceForm?.brokenRice}
              onChange={(e) =>
                setDeviceForm({
                  ...deviceForm,
                  brokenRice: e.target.value,
                })
              }
            />
          </li>

          <li>
            - ความชื่นข้าวเปลือก{" "}
            <Form.Input
              type="number"
              placeholder="ความชื่นข้าวเปลือก"
              value={deviceForm?.brokenRice}
              onChange={(e) =>
                setDeviceForm({
                  ...deviceForm,
                  brokenRice: e.target.value,
                })
              }
            />{" "}
            %
          </li>
       
          <li>
            - Capacity{" "}
            <Form.Input
              type="number"
              placeholder="Capacity"
              value={deviceForm?.riceMillingPerformance}
              onChange={(e) =>
                setDeviceForm({
                  ...deviceForm,
                  riceMillingPerformance: e.target.value,
                })
              }
            />{" "}
            Kg/Hr.
          </li>

          <li>
            - ข้าวกล้องหัก{" "}
            <Form.Input
              type="number"
              placeholder="ข้าวกล้องหัก"
              value={deviceForm?.brokenRice}
              onChange={(e) =>
                setDeviceForm({
                  ...deviceForm,
                  brokenRice: e.target.value,
                })
              }
            />{" "}
            %
          </li>

          <li>
            - ข้าวกล้องรวม{" "}
            <Form.Input
              type="number"
              placeholder="ข้าวกล้องรวม"
              value={deviceForm?.goodRice}
              onChange={(e) =>
                setDeviceForm({
                  ...deviceForm,
                  goodRice: e.target.value,
                })
              }
            />{" "}
            %
          </li>
        
          <li>
            - กากข้าว{" "}
            <Form.Input
              type="number"
              placeholder="กากข้าว"
              value={deviceForm?.brokenRice}
              onChange={(e) =>
                setDeviceForm({
                  ...deviceForm,
                  brokenRice: e.target.value,
                })
              }
            />{" "}
            %
          </li>

          <li>
            - ข้าวกล้องเต็ม{" "}
            <Form.Input
              type="number"
              placeholder="ข้าวกล้องเต็ม"
              value={deviceForm?.riceMillingPerformance}
              onChange={(e) =>
                setDeviceForm({
                  ...deviceForm,
                  riceMillingPerformance: e.target.value,
                })
              }
            />{" "}
             %
          </li>
         
          <li>ประสิทธิภาพในการสีข้าว (ส่วนข้าวขาว)</li>
          <li>
            - ข้าวขาวรวม{" "}
            <Form.Input
              type="number"
              placeholder="ข้าวขาวรวม"
              value={deviceForm?.riceMillingPerformance}
              onChange={(e) =>
                setDeviceForm({
                  ...deviceForm,
                  riceMillingPerformance: e.target.value,
                })
              }
            />{" "}
             %
          </li>

          <li>
            - ข้าวขาวเต็ม{" "}
            <Form.Input
              type="number"
              placeholder="ข้าวขาวเต็ม"
              value={deviceForm?.riceMillingPerformance}
              onChange={(e) =>
                setDeviceForm({
                  ...deviceForm,
                  riceMillingPerformance: e.target.value,
                })
              }
            />{" "}
             %
          </li>

          <li>
            - ข้าวขาวหัก{" "}
            <Form.Input
              type="number"
              placeholder="ข้าวขาวหัก"
              value={deviceForm?.riceMillingPerformance}
              onChange={(e) =>
                setDeviceForm({
                  ...deviceForm,
                  riceMillingPerformance: e.target.value,
                })
              }
            />{" "}
             %
          </li>

          <li>
            - ค่าความขาวข้าว{" "}
            <Form.Input
              type="number"
              placeholder="ค่าความขาวข้าว"
              value={deviceForm?.riceMillingPerformance}
              onChange={(e) =>
                setDeviceForm({
                  ...deviceForm,
                  riceMillingPerformance: e.target.value,
                })
              }
            />{" "}
             %
          </li>         
        </ul>
      </>
    );
  };

  const seedsorting = () => {
    return (
      <>
        <ul>
          <li>
            - ความเร็วรอบกระพ้อ 1 {" "}
            <Form.Input
              type="number"
              placeholder="ความเร็วรอบกระพ้อ 1"
              value={deviceForm?.motorSpeed}
              onChange={(e) =>
                setDeviceForm({ ...deviceForm, amp: e.target.value })
              }
            />{" "}
            RPM
          </li>

          <li>
            - ความเร็วรอบกระพ้อ 2 {" "}
            <Form.Input
              type="number"
              placeholder="ความเร็วรอบกระพ้อ 2 "
              value={deviceForm?.crackerSpeed}
              onChange={(e) =>
                setDeviceForm({ ...deviceForm, crackerSpeed: e.target.value })
              }
            />{" "}
            RPM
          </li>

          <li>
            - ความเร็วรอบกระพ้อ 3 {" "}
            <Form.Input
              type="number"
              placeholder="ความเร็วรอบกระพ้อ 3"
              value={deviceForm?.crackerSpeed}
              onChange={(e) =>
                setDeviceForm({ ...deviceForm, crackerSpeed: e.target.value })
              }
            />{" "}
            RPM
          </li>

          <li>
            - ความเร็วรอบตะแกรงโยก {" "}
            <Form.Input
              type="number"
              placeholder="ความเร็วรอบตะแกรงโยก"
              value={deviceForm?.crackerSpeed}
              onChange={(e) =>
                setDeviceForm({ ...deviceForm, crackerSpeed: e.target.value })
              }
            />{" "}
            RPM
          </li>

          <li>
            - แรงลมดูด {" "}
            <Form.Input
              type="number"
              placeholder="แรงลมดูด"
              value={deviceForm?.crackerSpeed}
              onChange={(e) =>
                setDeviceForm({ ...deviceForm, crackerSpeed: e.target.value })
              }
            />{" "}
            m/s
          </li>

          <li>
            - Capacity{" "}
            <Form.Input
              type="number"
              placeholder="Capacity"
              value={deviceForm?.riceMillingPerformance}
              onChange={(e) =>
                setDeviceForm({
                  ...deviceForm,
                  riceMillingPerformance: e.target.value,
                })
              }
            />{" "}
            Kg/Hr.
          </li>

          <li>
            - ปริมาณสิ่งเจือปน{" "}
            <Form.Input
              type="number"
              placeholder="ปริมาณสิ่งเจือปน"
              value={deviceForm?.riceMillingPerformance}
              onChange={(e) =>
                setDeviceForm({
                  ...deviceForm,
                  riceMillingPerformance: e.target.value,
                })
              }
            />{" "}
             %
          </li> 

          <li>
            - แรงดันไฟฟ้า{" "}
            <Form.Input
              type="number"
              placeholder="แรงดันไฟฟ้า"
              value={deviceForm?.voltage}
              onChange={(e) =>
                setDeviceForm({ ...deviceForm, voltage: e.target.value })
              }
            />{" "}
            V
          </li>

          <li>
            - กระแสไฟฟ้า{" "}
            <Form.Input
              type="number"
              placeholder="กระแสไฟฟ้า"
              value={deviceForm?.amp}
              onChange={(e) =>
                setDeviceForm({ ...deviceForm, amp: e.target.value })
              }
            />{" "}
            A
          </li>

          <li>
            <Form>
              <Form.TextArea
                label="สมรรถนะหลัง Setting"
                placeholder="สมรรถนะหลัง Setting"
                value={deviceForm?.summaryPerformance}
                onChange={(e) =>
                  setDeviceForm({
                    ...deviceForm,
                    summaryPerformance: e.target.value,
                  })
                }
              />
            </Form>
          </li>
        </ul>
      </>
    );
  };

  const longTailDevice = () => {
    return (
      <>
        <ul>
        <Form>
          <li> การสั่นสะเทือน </li>
          <Form.Checkbox
            label="น้อย"    
          />
          <Form.Checkbox
            label="ปานกลาง"
          />
           <Form.Checkbox
            label="มาก"
          />

          <li> การรั่วซึมของน้ำมัน </li>
          <Form.Checkbox
            label="ไม่มี"    
          />
          <Form.Checkbox
            label="เล็กน้อย"
          />
           <Form.Checkbox
            label="มาก"
          />

          <li> เสียงเกียร์ </li>
          <Form.Checkbox
            label="ปกติ"    
          />
          <Form.Checkbox
            label="ผิดปกติเล็กน้อย"
          />
           <Form.Checkbox
            label="ดังมาก"
          />

          <li> ความร้อน </li>
          <Form.Checkbox
            label="30°C ~ 40°C"    
          />
          <Form.Checkbox
            label="40°C ~ 45°C"
          />
           <Form.Checkbox
            label="มากกว่า 45°C"
          />
        </Form>
        </ul>
      </>
    );
  };

  const agricutureDevice = () => {
    return (
      <>
        <ul>
          <li>
            <Form>
              <Form.TextArea
                label="ข้อมูล Setting"
                placeholder="ข้อมูล Setting"
                value={deviceForm?.result}
                onChange={(e) =>
                  setDeviceForm({ ...deviceForm, result: e.target.value })
                }
              />
            </Form>
          </li>
          {/* <li>
            <Form>
              <Form.TextArea
                label="สมรรถนะหลัง Setting"
                placeholder="สมรรถนะหลัง Setting"
                value={deviceForm?.summaryPerformance}
                onChange={(e) =>
                  setDeviceForm({
                    ...deviceForm,
                    summaryPerformance: e.target.value,
                  })
                }
              />
            </Form>
          </li> */}
        </ul>
      </>
    );
  };

  const getRejectPart = () => {
    return (
      <>
        <Table celled className="rejectPart">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>ชื่ออะไหล่</Table.HeaderCell>
              <Table.HeaderCell>จำนวน</Table.HeaderCell>
              <Table.HeaderCell>สถานะ</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {rejectPart?.map((part, idx) => (
              <Table.Row key={idx}>
                <Table.Cell>
                  <Form>
                    <input
                      placeholder="ชื่ออะไหล่"
                      value={part?.partName || ""}
                      onChange={(e) => {
                        let newPartUse = rejectPart;
                        newPartUse[idx]["partName"] = e.target.value;
                        setRejectPart([...newPartUse]);
                      }}
                    />
                  </Form>
                </Table.Cell>
                <Table.Cell>
                  <Form>
                    <input
                      type="number"
                      placeholder="จำนวน"
                      value={part?.qty || ""}
                      onChange={(e) => {
                        let newPartUse = rejectPart;
                        newPartUse[idx]["qty"] = parseInt(e.target.value);
                        setRejectPart([...newPartUse]);
                      }}
                    />
                  </Form>
                </Table.Cell>
                <Table.Cell>
                  {idx ? (
                    <Button
                      color="red"
                      onClick={() => {
                        console.log(idx);
                        let newPartUseList = rejectPart;
                        newPartUseList.splice(idx, 1);
                        setRejectPart([...newPartUseList]);
                      }}
                    >
                      ลบ
                    </Button>
                  ) : (
                    <Button
                      color="teal"
                      onClick={() =>
                        setRejectPart([...rejectPart, { partName: "", qty: 0 }])
                      }
                    >
                      เพิ่ม
                    </Button>
                  )}
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </>
    );
  };

  const getAdjustPart = () => {
    return (
      <>
        <Table celled className="adjustPart">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>ชื่ออะไหล่</Table.HeaderCell>
              <Table.HeaderCell>จำนวน</Table.HeaderCell>
              <Table.HeaderCell>สถานะ</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {adjustPart?.map((part, idx) => (
              <Table.Row key={idx}>
                <Table.Cell>
                  <Form>
                    <input
                      placeholder="ชื่ออะไหล่"
                      value={part?.partName || ""}
                      onChange={(e) => {
                        let newPartUse = adjustPart;
                        newPartUse[idx]["partName"] = e.target.value;
                        setAdjustPart([...newPartUse]);
                      }}
                    />
                  </Form>
                </Table.Cell>
                <Table.Cell>
                  <Form>
                    <input
                      type="number"
                      placeholder="จำนวน"
                      value={part?.qty || ""}
                      onChange={(e) => {
                        let newPartUse = adjustPart;
                        newPartUse[idx]["qty"] = parseInt(e.target.value);
                        setAdjustPart([...newPartUse]);
                      }}
                    />
                  </Form>
                </Table.Cell>
                <Table.Cell>
                  {idx ? (
                    <Button
                      color="red"
                      onClick={() => {
                        console.log(idx);
                        let newPartUseList = adjustPart;
                        newPartUseList.splice(idx, 1);
                        setAdjustPart([...newPartUseList]);
                      }}
                    >
                      ลบ
                    </Button>
                  ) : (
                    <Button
                      color="teal"
                      onClick={() =>
                        setAdjustPart([...adjustPart, { partName: "", qty: 0 }])
                      }
                    >
                      เพิ่ม
                    </Button>
                  )}
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </>
    );
  };

  const createButton = () => {
    return (
      <>
        {users.userDetail?.role !== "sc" && users.userDetail?.role !== "st" && (
          <>
            <Button color="teal" onClick={() => onUpdateMaintenance("save")}>
              <Icon name="save outline" />
              บันทึก
            </Button>
          </>
        )}
        &emsp;

        {/* {users.userDetail?.role !== "sc" && (
          <>
            <Button color="green" onClick={() => onUpdateMaintenance("approve")}>
              <Icon name="save outline" />
              อนุมัติปิดเรื่อง
            </Button>
          </>
        )}
        &emsp; */}

        {users.userDetail?.role === "manager" && (
          <>
            <Button
              basic
              color="green"
              onClick={() => onUpdateMaintenance("reject")}
            >
              <Icon name="x" />
              ไม่อนุมัติ
            </Button>
            &emsp;
            <Button
              color="olive"
              onClick={() => onUpdateMaintenance("approve")}
            >
              <Icon name="check" />
              อนุมัติปิดเรื่อง
            </Button>
          </>
        )}

      </>
    );
  };

  const addDatetimePending = () => {
    return (
      <>
        <Table celled className="adjustPart">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>วันที่เริ่ม</Table.HeaderCell>
              <Table.HeaderCell>เวลา</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {adjustPart?.map((part, idx) => (
              <Table.Row key={idx}>
                <Table.Cell>
                  <Form>
                    <input
                      placeholder="วันที่เริ่ม"
                      value={part?.partName || ""}
                      onChange={(e) => {
                        let newPartUse = adjustPart;
                        newPartUse[idx]["partName"] = e.target.value;
                        setAdjustPart([...newPartUse]);
                      }}
                    />
                  </Form>
                </Table.Cell>
                <Table.Cell>
                  <Form>
                    <input
                      type="number"
                      placeholder="เวลา"
                      value={part?.qty || ""}
                      onChange={(e) => {
                        let newPartUse = adjustPart;
                        newPartUse[idx]["qty"] = parseInt(e.target.value);
                        setAdjustPart([...newPartUse]);
                      }}
                    />
                  </Form>
                </Table.Cell>              
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </>
    );
  };

  const sections = [
    { key: "หน้าแรก", content: <a href="/home">หน้าแรก</a>, link: true },
    { key: "รอดำเนินการซ่อม", content: <a href="/pending-list">รอดำเนินการซ่อม</a>, link: true, },
    { key: `${id}`, content: `${id}`, active: true, },
  ];

  return (
    <div className="pendingOrderDetail">
      <LetterLoading isOpen={isLoading} />
      <Sidebar tabActive="pending" />
      <Navigation />

      <div className="pendingOrderDetail-content">
        <h2>รอดำเนินการซ่อม</h2>
        <hr />
        <Breadcrumb icon="right angle" sections={sections} />

        <div className="pendingOrderDetail-content-inform">
          {<MaintenanceAdd order={maintenanceDetail} />}
        </div>

        <div className="pendingOrderDetail-content-handle">
          {<MaintenanceHandle order={maintenanceDetail} />}
        </div>

        {users.userDetail?.role !== "sc" && (
          <div className="pendingOrderDetail-content-maintenance">
          <Divider horizontal>
            <Header as="h3">
              <Icon name="wrench" />
              ดำเนินการซ่อม
            </Header>
          </Divider>
          {createMaintenanceForm()}
          </div>
        )}

        <div className="pendingOrderDetail-content-button">
          {createButton()}
        </div>
      </div>
    </div>
  );
}
